export default __webpack_public_path__ + "static/media/black-eye.18880724.svg";